import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import NhanVayApi from "service/nhanVayApi";
import { formatNumber } from "utils/currencyFormat";
import ChiTietTaiSanContainer from "containers/Common/TaiSan/ChiTietTaiSanContainer";
import configs from "../../../constants/configs";
export const TaiSanCamCo = ({ hopdong }) => {
  const dataInit = {
    List: [],
    TongTienPhiKho: 0,
  };
  const [dataTaiSanCamCo, UpdateDataTaiSanCamCo] = useState(dataInit);

  const dataInitTaiSan = {
    taiSanId: 0,
  };
  const [dataChiTietTaiSan, UpdateDataChiTietTaiSan] = useState(dataInitTaiSan);
  const DanhSachTaiSanCamCo = () => {

    NhanVayApi.getTaiSanCamCoNhanVay(hopdong.NhanVayID).then((response) => {
      UpdateDataTaiSanCamCo({
        ...dataTaiSanCamCo,
        List: response.data.List,
        TongTienPhiKho: response.data.TongTienPhiKho,
      });
    });
  };

  useEffect(() => {
    if (hopdong.NhanVayID > 0) {
      DanhSachTaiSanCamCo();
      UpdateDataChiTietTaiSan({
        ...dataChiTietTaiSan,
        taiSanId: hopdong.DsTaiSanNhanVay.map((item) => item.TaiSanId),
      });
    }
  }, []);
  //End fix height tab
  const [showModalTaiSan, setShowModalTaiSan] = useState(false);
  const [taiSanId, setTaiSanId] = useState([]);
  const setModalTaiSan = (taiSanId) => {
    if (taiSanId != null) {
      setTaiSanId(taiSanId);
    }
    setShowModalTaiSan(!showModalTaiSan);
  };

  const returnImageLink = (strImage) => {
    if (strImage === "" || strImage == null) {
      return configs.imageServer + "/images/no_image.png";
    } else {
      if (strImage && strImage.indexOf("http") > -1) {
        return strImage;
      } else {
        if (strImage.substring(0, 7) == "Morman/" || strImage.substring(0, 5) == "Temp/") {
          return configs.apiViewUpload + strImage;
        } else {
          return configs.imageServer + strImage;
        }
      }
    }
  };

  const listItem = () => {
    return (
      hopdong.DsTaiSanNhanVay != null &&
      hopdong.DsTaiSanNhanVay.map((item, index) => {
        let NoteTaiSan = item.TaiSanNote;
        return (
          <>
            <div class="col-md-9">{NoteTaiSan}</div>
          </>
        );
      })
    );
  };
  const listItem1 = () => {
    return (
      hopdong.DsTaiSanNhanVay != null &&
      hopdong.DsTaiSanNhanVay.map((item, index) => {
        let lstAnh = item.AnhTaiSan ? item.AnhTaiSan.split(";") : [];
        return (
          <>
            <div className="main-slider slider-ts">
              {lstAnh.map((item) => (
                <a href={item} data-fancybox="images">
                  <img src={returnImageLink(item)} alt="" style={{height:"150px", paddingLeft:"10px"}} />
                </a>
              ))}
            </div>
          </>
        );
      })
    );
  };
  return (
    <>
      <div class="Left808x200">
        <div id="ctl00_ContentPlaceHolder_ViewDetailChoVay_UpdatePanel12">
          <div class="form-body form-bordered-1">
            <div class="form-group row last-1">
              <label class="col-md-3 label-control">Tên tín chấp</label>
              {listItem()}
            </div>
          </div>
        </div>
      </div>
      {listItem1()}
    </>
  );
};
